/* Cookies NY · Landing V6: simulador, cuenta regresiva, barra fija y WhatsApp */
(function () {
  'use strict';

  function money(n) {
    return '$' + Math.max(0, Math.round(n)).toLocaleString('es-AR');
  }

  /* ---------- Simulador de ingresos ---------- */
  function initSim(root) {
    var sim = root.querySelector('[data-cny-sim]');
    if (!sim) return;
    var qty = sim.querySelector('[data-cny-qty]');
    var qtyOut = sim.querySelector('[data-cny-qty-out]');
    var p = sim.querySelector('[data-cny-p]');
    var c = sim.querySelector('[data-cny-c]');
    var outMonth = sim.querySelector('[data-cny-month]');
    var outWeek = sim.querySelector('[data-cny-week]');
    var outPay = sim.querySelector('[data-cny-payback]');
    var chips = sim.querySelectorAll('[data-cny-preset]');
    var weeks = parseFloat(sim.dataset.week) || 4.3;
    var ebook = parseFloat(root.dataset.price) || 0;
    var shown = 0;
    var raf = null;

    function animateTo(target) {
      if (raf) cancelAnimationFrame(raf);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { shown = target; outMonth.textContent = money(target); return; }
      var from = shown, start = null, dur = 450;
      function step(t) {
        if (!start) start = t;
        var k = Math.min(1, (t - start) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        shown = from + (target - from) * e;
        outMonth.textContent = money(shown);
        if (k < 1) raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }

    function update() {
      var q = parseFloat(qty.value) || 0;
      var price = parseFloat(p.value) || 0;
      var cost = parseFloat(c.value) || 0;
      var margin = Math.max(0, price - cost);
      var week = q * margin;
      qtyOut.textContent = q;
      var min = parseFloat(qty.min) || 0, max = parseFloat(qty.max) || 100;
      qty.style.setProperty('--fill', ((q - min) / (max - min) * 100) + '%');
      outWeek.textContent = money(week);
      outPay.textContent = margin > 0 ? Math.ceil(ebook / margin) : '–';
      chips.forEach(function (ch) { ch.classList.toggle('is-on', parseFloat(ch.dataset.cnyPreset) === q); });
      animateTo(week * weeks);
    }

    qty.addEventListener('input', update);
    p.addEventListener('input', update);
    c.addEventListener('input', update);
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () { qty.value = ch.dataset.cnyPreset; update(); });
    });
    shown = 0;
    update();
  }

  /* ---------- Cuenta regresiva (solo con fecha real cargada) ---------- */
  function initCountdown(root) {
    var box = root.querySelector('[data-cny-countdown]');
    if (!box) return;
    var alt = root.querySelector('[data-cny-countdown-alt]');
    var out = box.querySelector('[data-cny-count-out]');
    var raw = (box.dataset.end || '').trim();
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
    if (!m) return;
    var end = new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T' + (m[4] || '23') + ':' + (m[5] || '59') + ':00-03:00').getTime();
    if (isNaN(end)) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        box.hidden = true; if (alt) alt.hidden = false;
        if (box.parentNode && box.parentNode.parentNode) box.parentNode.parentNode.classList.remove('has-count');
        return false;
      }
      var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), mi = Math.floor(left % 36e5 / 6e4), s = Math.floor(left % 6e4 / 1e3);
      out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(mi) + ':' + pad(s);
      return true;
    }
    if (tick()) {
      box.hidden = false;
      if (alt) alt.hidden = true;
      if (box.parentNode && box.parentNode.parentNode) box.parentNode.parentNode.classList.add('has-count');
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    }
  }

  /* ---------- Barra fija + WhatsApp ---------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-cny-sticky]');
    var hero = root.querySelector('[data-cny-hero-buy]');
    var wa = root.querySelector('.cny-wa');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var link = bar.querySelector('a');
    var mq = window.matchMedia('(max-width: 989px)');
    var blockers = [root.querySelector('[data-cny-offer]'), root.querySelector('[data-cny-close]')].filter(Boolean);
    var passed = false, seen = new Set();

    function render() {
      var on = mq.matches && passed && seen.size === 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (link) link.tabIndex = on ? 0 : -1;
      var h = mq.matches ? bar.offsetHeight : 0;
      root.style.setProperty('--sticky-h', h + 'px');
      if (wa) wa.style.setProperty('--wa-lift', on ? h + 'px' : '0px');
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { passed = !e.isIntersecting && e.boundingClientRect.top < 0; });
      render();
    }).observe(hero);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      render();
    }, { threshold: 0.15 });
    blockers.forEach(function (b) { io.observe(b); });
    window.addEventListener('resize', render);
    render();
  }

  function init(root) {
    if (!root || root.dataset.cnyReady) return;
    root.dataset.cnyReady = '1';
    initSim(root);
    initCountdown(root);
    initSticky(root);
  }
  function boot() { document.querySelectorAll('[data-cny]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-cny]')); });
})();
